import { render, staticRenderFns } from "./JK.vue?vue&type=template&id=3b9e96ab&scoped=true&"
import script from "./JK.vue?vue&type=script&lang=js&"
export * from "./JK.vue?vue&type=script&lang=js&"
import style0 from "./JK.vue?vue&type=style&index=0&id=3b9e96ab&prod&lang=scss&scoped=true&"
import style1 from "./JK.vue?vue&type=style&index=1&id=3b9e96ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9e96ab",
  null
  
)

export default component.exports